/**
 * Document XML is Windows-1251. Decoding it as UTF-8 turns every Cyrillic
 * name into replacement characters — the single most common way to corrupt
 * ДПС data on the way in. See ai/docs/prro-api.md.
 */
export const DOCUMENT_ENCODING = "windows-1251";

export const XML_MIME_TYPE = "text/xml";

/** `<ORDERDATE>` is DDMMYYYY and `<ORDERTIME>` is HHMMSS, both wall-clock. */
export const ORDER_DATE_LENGTH = 8;

export const ORDER_TIME_LENGTH = 6;

/**
 * Payment form names ПРРО vendors use. The codes are not standardised across
 * vendors — a real receipt from one of them carries `PAYFORMCD` 301 for cash —
 * so the name is read first and the code is only a fallback.
 */
export const CASH_PAYMENT_PATTERN = /готів|cash/i;

export const CARD_PAYMENT_PATTERN = /карт|card|безготів/i;

/** `PAYFORMCD` as check01.xsd defines it, used when the name says nothing. */
export const CASH_PAYMENT_CODE = "0";

export const CARD_PAYMENT_CODE = "1";

/** `TYPE` of a tax row: 0 is ПДВ. Other rows are excise and retail duties. */
export const VAT_TAX_TYPE = "0";
